import { Card } from '../common/card'

export const AuraCore = ({ withoutHeading }) => {
  const cardData = [
    {
      icon: '/internal_job_board.svg',
      title: 'Internal Job Boards',
      desc: 'Branded, searchable roles for employees & alumni'
    },
    {
      icon: '/ai_refferals.svg',
      title: 'AI Referrals & Smart Matching',
      desc: 'Predictive tech, bias reduction, better fit'
    },
    {
      icon: '/candidate_engagement.svg',
      title: 'Candidate Re-Engagement',
      desc: 'Silver medalists & passive talent, activated'
    },
    {
      icon: '/refferal.svg',
      title: 'Referral Engine',
      desc: 'Track, reward, and scale warm introductions'
    },
    {
      icon: '/core_share.svg',
      title: 'CoreShare Collaboration',
      desc: 'Share top candidates with trusted recruiters'
    },
    {
      icon: '/analytics.svg',
      title: 'Analytics & Reward Automation',
      desc: 'Prove ROI, automate payouts'
    },
  ]
  return (
    <>
      {!withoutHeading &&
        <>
          <div className='text-2xl sm:text-4xl md:text-5xl lg:text-6xl lg:text-8xl font-oxanium font-medium flex justify-center max-w-7xl mx-auto text-center px-6'>
            <span className='text-white'>What is</span>
            <div className='text-[#04D1D6] ml-1 sm:ml-4 custom-icon'>AIAURA Core</div>
            <span className='text-white'>?</span>
          </div>
          <div className='font-lato font-light text-base sm:text-xl text-white max-w-7xl mx-auto text-center mt-6 px-6 sm:px-24'>
            <strong>AIAURA</strong> Core is your central hub for internal hiring, referrals, and recruiter-to-recruiter collaboration. Purpose-built for recruitment agencies and talent teams, it helps you fill roles faster, reduce costs, and activate talent you already know and unlock new value from your existing networks.
          </div>
        </>
      }
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 sm:gap-8 lg:gap-10 xl:gap-20 px-6 mt-16">
        {cardData.map((item, index) => {
          return (
            <Card item={item} key={index} />
          )
        })}
      </div>

    </>
  )
}
